(() => {

  const formatMoney = (cents, format = "") => {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }

  function initCustomWidget() {

    !window.customElements.get('custom-subscribe') && window.customElements.define(
      'custom-subscribe',
      class CustomSubscribe extends HTMLElement {
        constructor() {
          super();
          this.getElementAttributes();
          this.locateBuyButtons();
          this.relocateWidget();
        }

        locateBuyButtons() {
          this.buyButtonsEl = document.querySelector(this.buyButtonsSelector);
        }

        relocateWidget() {
          this.buyButtonsEl.parentNode.insertBefore(this, this.buyButtonsEl);
        }

        connectedCallback() {
          this.handlePurchaseType();
          this.updateCups();
          this.updatePrices();
          this.initTabs();
          this.handleQuickAdd();
          this.getAddToCartEl().then(() => {
            this.getAddToCartText();
            this.updateAddToCart('subscription');
            this.enableAddToCart();
          });
          this.activateWidget();
        }

        getElementAttributes() {
          this.productId = parseInt(this.getAttribute('product-id'));
          this.subscriptionOnly = this.getAttribute('subscription-only') === 'true';
          this.productWeight = parseInt(this.getAttribute('weight'));
          this.price = this.getAttribute('price') * 1;
          this.savingType = this.getAttribute('saving_type');
          this.saving = this.getAttribute('saving') * 1;
          this.defaultOptionText = this.getAttribute('option-text');
          this.appendOptionText = this.getAttribute('append-text');
          this.subscribeText = this.getAttribute('subscribe-text');
          this.cupWeight = this.getAttribute('cup-weight') * 1;
          this.buyButtonsSelector = this.getAttribute('buy-buttons-selector');
          this.cups = Math.round(this.productWeight / this.cupWeight);
        }

        handleQuickAdd() {
          this.quickAddEl = this.closest('.exh-quick-add');
          if (!this.quickAddEl) return;
          this.disclosureTarget = this.quickAddEl.querySelector('.exh-quick-add-disclosure');
          this.disclosureTrigger = this.quickAddEl.querySelector('[data-disclose-quick-add]');
          this.disclosureTrigger.addEventListener('click', ev => {
            ev.preventDefault();
            ev.currentTarget.style.display = 'none';
            this.disclosureTarget.classList.add('exh-fade');
          });
          this.disclosureTrigger.style.display = 'block';
          this.disclosureTarget.querySelectorAll('variant-option-value').forEach(vov => vov.style.display = 'none');
        }

        handlePurchaseType() {
          if (this.subscriptionOnly) {
            this.querySelector('.wrapper').classList.add('wrapper--subscription-only')
          }
        }

        initTabs() {
          this.tabs = this.querySelectorAll('.tab') || [];
          this.tabLabels = this.querySelectorAll('.triggers label');
          this.tabTriggers = this.querySelectorAll('[name="purchaseOption"]');
          this.tabTriggers.forEach(el => el.addEventListener('change', this.switchTab.bind(this)));
        }

        switchTab(e) {
          this.tabs.forEach(el => el.classList.toggle('active'));
          this.tabLabels.forEach(el => el.classList.toggle('active'));
          let currentTab = this.querySelector('.tab.active');
          let name = (currentTab.id == 'onetime') ? '' : 'selling_plan';
          this.querySelector('[data-select]').setAttribute('name', name);
          this.updateAddToCart(currentTab.id);
        }

        showCups() {
          return !isNaN(this.productWeight);
        }

        updateCups() {
          if (!this.showCups()) {
            this.querySelectorAll('.ppc').forEach(el => el.style.display = 'none');
            return;
          }
          this.querySelectorAll('.product-weight').forEach(el => el.innerText = `${this.productWeight}g`);
          this.querySelectorAll('.cups').forEach(el => el.innerText = `${this.cups} cups`);
        }

        updatePrices() {
          let subscriptionDiscount = 1;
          if (this.savingType === 'percentage') {
            subscriptionDiscount = this.saving;
          }
          let unitPrice = this.price;
          let subscribePrice = (unitPrice * (1 - (subscriptionDiscount / 100)));
          let saving = subscriptionDiscount;

          this.querySelector('#onetime .old-price').innerText = '';

          if (unitPrice === subscribePrice) {
            this.querySelector('#subscription .old-price').innerText = '';
            this.querySelector('.subscribe-offer').innerText = '';
          } else {
            this.querySelector('#subscription .old-price').innerText = formatMoney(unitPrice);
            this.querySelector('.subscribe-offer').innerText = `${saving}% off`;
          }
          if (unitPrice === 0) {
            this.querySelector('.onetime-price').innerText = 'FREE';
          } else {
            this.querySelector('.onetime-price').innerText = formatMoney(unitPrice);
          }
          if (subscribePrice === 0) {
            this.querySelector('.subscribe-price').innerText = 'FREE';
          } else {
            this.querySelector('.subscribe-price').innerText = formatMoney(subscribePrice);
          }

          if (!this.showCups()) return;
          let subscribeCupPrice = (subscribePrice) / this.cups;
          let onetimeCupPrice = (unitPrice) / this.cups;

          this.querySelector('.subscribe-cup-price').innerText = `${formatMoney(subscribeCupPrice)}`;
          this.querySelector('.onetime-cup-price').innerText = `${formatMoney(onetimeCupPrice)}`;
        }

        async getAddToCartEl() {
          await customElements.whenDefined(this.buyButtonsEl.localName);
        }

        getAddToCartText() {
          this.addToCartTextEl = this.buyButtonsEl.querySelector('button div');
          this.addToCartText = this.addToCartTextEl?.innerText || 'Add to cart';
        }

        updateAddToCart(key) {
          this.addToCartTextEl.innerText = (key == 'subscription') ? this.subscribeText : this.addToCartText;
        }

        enableAddToCart() {
          this.buyButtonsEl.classList.add('exh-fade');
        }

        activateWidget() {
          this.querySelector('.wrapper').classList.add('exh-fade');
        }
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomWidget);
  } else {
    initCustomWidget();
  }

  window.addEventListener('shopify:section:load', initCustomWidget);

})();
